define('mixins/ReflowMixin',['require','react','react-dom'],function(require) {

  var React = require('react');
  var ReactDOM = require('react-dom');

  return {
    reflow: function() {
      return ReactDOM.findDOMNode(this).offsetHeight;
    }
  };
});

